import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

// Adapter pt-BR: interpreta e exibe datas no formato dd/mm/aaaa nos mat-datepicker
@Injectable()
export class BrDateAdapter extends NativeDateAdapter {

  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) { return null; }
      const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (match) {
        const day = +match[1];
        const month = +match[2] - 1;
        const year = +match[3];
        const date = new Date(year, month, day);
        // valida (ex.: 31/02 vira inválida)
        if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
          return date;
        }
        return new Date(NaN);
      }
      return new Date(NaN);
    }
    return super.parse(value);
  }

  override format(date: Date, displayFormat: any): string {
    // Os rótulos de cabeçalho do calendário (monthYearLabel/monthYearA11yLabel)
    // são os únicos formatos sem 'day'. Sem esse desvio o título do calendário
    // saía como "01/08/2026" em vez de "Agosto 2026".
    if (displayFormat && displayFormat.day == null) {
      return `${MESES[date.getMonth()]} ${date.getFullYear()}`;
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${date.getFullYear()}`;
  }
}
